export const inhouseGames = [
  {
    slug: "limbo",
    name: "Limbo",
    category: "Originals",
    description: "Pick a target multiplier and see if the round flies above it.",
    accent: "from-emerald-500/25 via-cyan-500/20 to-slate-900",
    edge: "Up to 25x",
  },
  {
    slug: "dice-duel",
    name: "Dice Duel",
    category: "Originals",
    description: "Choose over or under and tune the line for bigger risk and reward.",
    accent: "from-sky-500/25 via-blue-500/20 to-slate-900",
    edge: "Custom odds",
  },
  {
    slug: "coin-toss",
    name: "Coin Toss",
    category: "Instant Win",
    description: "Simple 50-50 pressure with a near-double payout.",
    accent: "from-amber-500/25 via-orange-500/20 to-slate-900",
    edge: "1.96x",
  },
  {
    slug: "lucky-wheel",
    name: "Lucky Wheel",
    category: "Originals",
    description: "Spin low, medium, or high risk wheels with different multiplier ladders.",
    accent: "from-fuchsia-500/25 via-pink-500/20 to-slate-900",
    edge: "Risk tiers",
  },
  {
    slug: "keno",
    name: "Mini Keno",
    category: "Arcade",
    description: "Lock three numbers, wait for the draw, and chase the clean sweep.",
    accent: "from-violet-500/25 via-indigo-500/20 to-slate-900",
    edge: "Up to 5x",
  },
  {
    slug: "mines",
    name: "Mines Rush",
    category: "Originals",
    description: "Call safe tiles on a 5x5 board and avoid the buried traps.",
    accent: "from-rose-500/25 via-red-500/20 to-slate-900",
    edge: "Board strategy",
  },
  {
    slug: "hi-lo",
    name: "Hi-Lo",
    category: "Arcade",
    description: "Read the next card correctly and ride a quick one-step payout.",
    accent: "from-cyan-500/25 via-teal-500/20 to-slate-900",
    edge: "Card pick",
  },
  {
    slug: "plinko-lite",
    name: "Plinko Lite",
    category: "Originals",
    description: "Drop the chip into low, medium, or high-risk peg paths.",
    accent: "from-lime-500/25 via-green-500/20 to-slate-900",
    edge: "Weighted drops",
  },
  {
    slug: "roulette-mini",
    name: "Roulette Mini",
    category: "Table",
    description: "Bet red, black, odd, or even and spin a compact wheel.",
    accent: "from-red-500/25 via-orange-500/20 to-slate-900",
    edge: "Classic table",
  },
  {
    slug: "slots-sprint",
    name: "Slots Sprint",
    category: "Slots",
    description: "A fast three-reel spin with pairs, triples, and jackpot sevens.",
    accent: "from-yellow-500/25 via-amber-500/20 to-slate-900",
    edge: "10x jackpot",
  },
  {
    slug: "dragon-tower",
    name: "Dragon Tower",
    category: "Arcade",
    description: "Pick how many floors to climb before the tower collapses.",
    accent: "from-emerald-500/25 via-lime-500/20 to-slate-900",
    edge: "Progressive risk",
  },
  {
    slug: "scratch-gold",
    name: "Scratch Gold",
    category: "Instant Win",
    description: "Reveal three hidden symbols and hunt matching treasure icons.",
    accent: "from-amber-500/25 via-yellow-500/20 to-slate-900",
    edge: "Quick reveal",
  },
];

export const inhouseCategories = [
  "All",
  "Originals",
  "Instant Win",
  "Arcade",
  "Table",
  "Slots",
];

export function getInhouseGame(slug) {
  return inhouseGames.find((game) => game.slug === slug) || null;
}
